var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851",
    transform: "translate(1.482 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    transform: "translate(-0.482)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "translate( -1.5 -1 )"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    d: "m22.498,8.27289l2.92458,0l-6.42136,7.31145l7.50218,9.91814l-5.88731,0l-4.60939,-6.02718l-5.27696,6.02718l-2.92458,0l6.80283,-7.82007l-7.18429,-9.40952l6.03354,0l4.16435,5.50584l4.87642,-5.50584zm-1.0236,15.51299l1.62123,0l-10.49034,-13.85997l-1.74203,0l10.61114,13.85997z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCX);
export default __webpack_public_path__ + "static/media/icon_c_x.c66652a16f587064481d7f95d84db233.svg";
export { ForwardRef as ReactComponent };